import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { PublicDataResponse } from '@/types/api';

export interface PublicDataParams {
  start_date: string;
  end_date: string;
  agg_level?: string;
}

export function usePublicData(params: PublicDataParams) {
  return useQuery({
    queryKey: ['public', 'data', params],
    queryFn: async () => {
      const res = await apiClient.get<PublicDataResponse>('/public/data', {
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
          agg_level: params.agg_level ?? '1h',
        },
      });
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !!params.start_date && !!params.end_date,
  });
}
